import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../utils/AuthContext';
import { useLang } from '../utils/LanguageContext';
import { t } from '../utils/translations';
import './LoginScreen.css';

// Shown when the user arrives from a password-reset email link.
function ResetPasswordScreen() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const { clearRecovery, signOut } = useAuth();
  const { lang, toggleLang } = useLang();
  const tr = t[lang];

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 8) {
      setError(tr.passwordShort);
      return;
    }
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setError(tr.signUpError);
      setBusy(false);
    } else {
      // Already logged in via the recovery link — continue into the app
      clearRecovery();
    }
  }

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={handleSubmit}>
        <button type="button" className="lang-btn login-lang" onClick={toggleLang}>
          {lang === 'fr' ? 'FR' : lang === 'en' ? 'EN' : 'ع'}
        </button>

        <div className="login-icon">🔑</div>
        <h1 className="login-title">StratosPOS</h1>
        <p className="login-sub">{tr.chooseNewPassword}</p>

        <input
          type="password"
          placeholder={tr.newPassword}
          value={password}
          onChange={e => setPassword(e.target.value)}
          className="login-input login-input-text"
          autoComplete="new-password"
          autoFocus
          required
        />

        {error && <p className="login-error">❌ {error}</p>}

        <button type="submit" className="login-btn" disabled={busy}>
          {busy ? '...' : tr.save}
        </button>

        <button type="button" className="login-switch" onClick={() => { clearRecovery(); signOut(); }}>
          {tr.cancel}
        </button>
      </form>
    </div>
  );
}

export default ResetPasswordScreen;
